<template>
    <div @mouseover="showInfoTooltip" @mouseleave="hideInfoTooltip">
        <switch-input :value="isToggleOn" :shouldShowInfoTooltip="shouldShowInfoTooltip" @change="onToggleClick">
            <template #inlineIcon>
                <svg v-if="!isToggleOn" style="height: 20px; width: 20px">
                    <use xlink:href="#eye-off" />
                </svg>
                <svg v-else-if="isToggleOn" style="height: 20px; width: 20px">
                    <use xlink:href="#eye-on" />
                </svg>
            </template>
            <template #infoTooltip>
                <span v-if="!isToggleOn">{{ $t('forms.auth.register.fields.password.show_password') }}</span>
                <span v-else-if="isToggleOn">{{ $t('forms.auth.register.fields.password.hide_password') }}</span>
            </template>
        </switch-input>
    </div>
</template>

<script>
    import SwitchInput from 'components/form-inputs/SwitchInput'

    export default {
        components: {
            SwitchInput,
        },

        data() {
            return {
                isToggleOn: false,
                shouldShowInfoTooltip: false,
            }
        },

        methods: {
            onToggleClick() {
                this.isToggleOn = !this.isToggleOn
                this.$emit('visibility-toggle-switch', { isToggleOn: this.isToggleOn })
            },

            showInfoTooltip() {
                this.shouldShowInfoTooltip = true
            },

            hideInfoTooltip() {
                this.shouldShowInfoTooltip = false
            },
        },
    }
</script>
